// Core component styles
const coreStyles={container:{}};/**
 * Combine component context styles with core styles
 * @param {Object} contextStyles
 * @return {Object}
 */const getStyles=function(){let contextStyles=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};return{container:{...coreStyles.container,...contextStyles.container}};};export default getStyles;